import { useState, useEffect } from 'react';
import { supabase } from '../config/supabase';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export const useQuizzes = () => {
  const { user } = useAuth();
  const [quizzes, setQuizzes] = useState([]);
  const [quizAttempts, setQuizAttempts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuizzes();
    if (user) {
      fetchQuizAttempts();
    }
  }, [user]);

  const fetchQuizzes = async () => {
    try {
      const { data, error } = await supabase
        .from('quizzes')
        .select(`
          *,
          quiz_questions (*)
        `)
        .order('created_at', { ascending: false });

      if (error) throw error;
      setQuizzes(data || []);
    } catch (error) {
      console.error('Error fetching quizzes:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuizAttempts = async () => {
    try {
      const { data, error } = await supabase
        .from('quiz_attempts')
        .select('*')
        .eq('user_id', user.id)
        .order('attempted_at', { ascending: false });

      if (error) throw error;
      setQuizAttempts(data || []);
    } catch (error) {
      console.error('Error fetching quiz attempts:', error);
    }
  };

  const submitQuizAttempt = async (quizId, score, answers) => {
    try {
      const { data, error } = await supabase
        .from('quiz_attempts')
        .insert([{
          user_id: user.id,
          quiz_id: quizId,
          score: score,
          answers: answers,
          attempted_at: new Date().toISOString()
        }])
        .select()
        .single();

      if (error) throw error;

      setQuizAttempts(prev => [data, ...prev]);
      toast.success(`Quiz completed! Score: ${score}%`);
      return { data, error: null };
    } catch (error) {
      console.error('Error submitting quiz attempt:', error);
      toast.error('Failed to submit quiz');
      return { data: null, error };
    }
  };

  const getQuizAttempts = (quizId) => {
    return quizAttempts.filter(attempt => attempt.quiz_id === quizId);
  };

  const getBestScore = (quizId) => {
    const attempts = getQuizAttempts(quizId);
    return attempts.length > 0 ? Math.max(...attempts.map(a => a.score)) : 0;
  };

  return {
    quizzes,
    quizAttempts,
    loading,
    submitQuizAttempt,
    getQuizAttempts,
    getBestScore,
    refetch: fetchQuizzes
  };
};